export default __webpack_public_path__ + "static/media/cp_geo_sz.af91e9da.svg";